import { RatesSignalTypes } from '@autos/auto-results/components/auto-detail-rates/constants/rates';
export interface RateUI {
  className: string;
  id: string;
  value: number;
  label: string;
  order: number;
  signal: RatesSignalTypes;
  percentage?: number;
}

export enum RatesTypes {
  Taxes = 'Taxes', // Monto total de los impuestos
  Total = 'Total', // Monto Total del Precio. Amount + Fees + Taxes + Surcharges - DiscountAmount + PenaltyAmount
  Amount = 'Amount', // Monto de la tarifa
  Fees = 'Fees', // Monto de los fees ,
  Surcharges = 'Surcharges', // Monto de los Surcharges ,
  DiscountAmount = 'DiscountAmount', // Monto total de los descuentos ,
  CommissionAmount = 'CommissionAmount', // Monto total de la comisión ,
  CurrencyCode = 'CurrencyCode', // Código de moneda en la cual se encuentran los montos del objeto ,
  PenaltyAmount = 'PenaltyAmount', // Field for exchanging penalties
  PaymentAgency = 'PaymentAgency',
  TotalPayNow = 'TotalPayNow',
  TotalPay = 'TotalPay'
}
